import type { MappedDialogParticipant } from './types';

export const sortParticipants = (
	bots: MappedDialogParticipant[]
): MappedDialogParticipant[] => {
	return bots.slice().sort((a, b) => {
		if (a.lastMessage?.timestamp === b.lastMessage?.timestamp) {
			return (
				a.sortingGroup - b.sortingGroup ||
				(a.accountType === 'influencer' && b.promoPriority - a.promoPriority) ||
				a.paymentOptionLevel - b.paymentOptionLevel ||
				a.name.localeCompare(b.name, undefined, {
					numeric: true,
					sensitivity: 'base',
				})
			);
		}

		return (b.lastMessage?.timestamp || 0) - (a.lastMessage?.timestamp || 0);
	});
};
